<template>
	<div>
		<div class="blog-category">
			{{ channelCategory }}
		</div>
		<h1 class="blog-title">
			{{ medrefdata.medrefTitle }}
		</h1>

		<div
			v-if="medrefdata.mainImagePath"
			class="blog-image-container"
		>
			<img
				:src="getImageURLPath(medrefdata.mainImagePath, 500)"
				:alt="medrefdata.mainImageAlt"
			/>
		</div>

		<div
			v-if="postAuthorName"
			class="blog-author-info"
		>
			<img
				class="author-thumbnail"
				v-if="postAuthorImg"
				:src="postAuthorImg"
				:alt="postAuthorName"
			/>
			<div class="author-content">
				<div
					v-if="postAuthorName"
					class="author-name"
				>
					By <a
						class="bold-content"
						:href="postAuthorUrl"
						v-html="postAuthorName"
					></a>
					<span
						class="publisheddate"
						v-if="postPublishedDate"
						v-html="formatDate(postPublishedDate)"
					>
					</span>
				</div>

				<div
					v-if="postAuthorLinkHeader"
					class="author-related-link-header"
					v-html="postAuthorLinkHeader"
				>
				</div>
			</div>
		</div>
	</div>

	<!-- eslint-disable vue/valid-template-root -->
	<div class="blog-disclaimer-text">
		<p>
			<span class="important-txt">
				Important:
			</span>
			The opinions expressed in WebMD Blogs are solely those of the User,
			who may or may not have medical or scientific training.
		</p>
		<p
			class="disc-full-txt"
			:class="{ expanded: this.isExpanded }"
		>
			These opinions do not represent the opinions of WebMD.
			Blogs are not reviewed by a WebMD physician or any member of the WebMD
			editorial staff for accuracy, balance, objectivity, or any other
			reason except for compliance with our Terms and Conditions.
			Some of these opinions may contain information about treatments
			or uses of drug products that have not been approved by the
			U.S. Food and Drug Administration. WebMD does not endorse any
			specific product, service or treatment.
		</p>
		<p
			class="disc-full-txt"
			:class="{ expanded: this.isExpanded }"
		>
			Do not consider WebMD Blogs as medical advice.
			Never delay or disregard seeking professional medical advice
			from your doctor or other qualified healthcare provider because
			of something you have read on WebMD. You should always speak with
			your doctor before you start, stop, or change any prescribed part
			of your care plan or treatment. WebMD understands that reading
			individual, real-life experiences can be a helpful resource,
			but it is never a substitute for professional medical advice,
			diagnosis, or treatment from a qualified health care provider.
			If you think you may have a medical emergency, call your doctor
			or dial 911 immediately.
		</p>

		<div>
			<a
				class="read-more"
				:class="{ expanded: this.isExpanded }"
				@click="updateFlag()"
			>
				Read More
				<i class="webmd-icon-down-arrow"></i>
			</a>
		</div>
	</div>
</template>
<script>

import _get from 'lodash/get';
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

export default {
	name: 'BlogHeader',
	props: {
		moduledata: {},
		medrefdata: {},
	},

	data() {
		return {
			isExpanded: false,
			moduleInfo: [],
			postPublication: '',
			channelCategory: '',
			postAuthorInfo: '',
			postPublishedDate: '',
			postAuthorImg: '',
			postAuthorName: '',
			postAuthorUrl: '',
			postAuthorLinkHeader: '',
		};
	},

	computed: {

	},

	created() {
		this.store = useStore(this.$pinia);
		this.moduleInfo = this.moduledata;
		const moduleData = this.moduleInfo.module_data || {};
		this.postPublication = _get(
			this.moduleInfo,
			'module_settings.metadata_section.wbmd_publ.wbmd_publ_display',
			'',
		);
		if (this.postPublication.includes('Expert')) {
			this.postPublication = 'Expert Blogs';
		} else if (this.postPublication.includes('Patient')) {
			this.postPublication = 'Patient Blogs';
		}

		const postChannel = _get(
			this.moduleInfo,
			'module_settings.metadata_section.wbmd_c_channel_id.wbmd_disp_nm',
			'',
		);
		this.channelCategory = `${this.postPublication} | ${postChannel.replace(
			'Blog - ',
			'',
		)}`;

		const moduleSettingsData = _get(
			this.moduleInfo,
			'module_settings.metadata_section',
			{},
		);
		this.postAuthorInfo = _get(
			moduleSettingsData,
			'wbmd_authr_prim_group.wbmd_authr_prim.wbmd_bio_obj_id',
			{},
		);
		this.postAuthorImg = _get(
			this.postAuthorInfo,
			'content_section.cons_bio.person_photo.path',
			'',
		);
		this.postAuthorName = _get(
			this.postAuthorInfo,
			'content_section.cons_bio.title',
			'',
		);
		this.postAuthorUrl = _get(this.postAuthorInfo, 'link_friendlyurl', '');
		this.postAuthorLinkHeader = _get(
			this.postAuthorInfo,
			'content_section.cons_bio.related_links_header',
			'',
		);
		const authorChronId = _get(
			moduleSettingsData,
			'wbmd_authr_prim_group.wbmd_authr_prim.wbmd_bio_obj_id.chronic_id',
			'',
		);
		if (!authorChronId) {
			this.postAuthorName = _get(
				moduleData,
				'content_section.cons_feature.related_links_header',
				'',
			);
			this.postAuthorLinkHeader = _get(
				moduleData,
				'content_section.cons_feature.related_links_text.p',
				'',
			);
		} else {
			this.postAuthorImg = `${this.getImageURLPath(this.postAuthorImg, 50)}`;
		}

		this.postPublishedDate = moduleSettingsData.wbmd_orig_pub_dt || '';
	},

	methods: {
		updateFlag() {
			this.isExpanded = true;
		},

		getImageURLPath(imgUrl, size) {
			const src = this.store.pagedata
				? this.store.pagedata.omniture.image_server_url
				: 'https://img.webmd.com/dtmcms/live';
			return `${src}${imgUrl}?resize=${size}px:*`;
		},

		formatDate(date) {
			const mydate = new Date(date);
			const d = mydate.getDate();

			const monthNames = [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			];
			const dateFormat = `${monthNames[mydate.getMonth()]} ${d}, ${mydate.getFullYear()}`;
			return dateFormat;
		},

	},

};
</script>
<style lang="scss">
@import '../stylesheets/_variables.scss';

.blog-disclaimer-text {
	color: $carbon;
	font-family: $base-font-family-sans;
	font-size: .875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 19.6px;
	letter-spacing: 0.7px;
	padding: .5rem 1rem 1.75rem .5rem;

	.important-txt {
		font-weight: 700;
	}

	p {
		margin-bottom: .3125rem;
	}

	.disc-full-txt {
		display: none;

		&.expanded {
			display: block;
		}
	}

	.read-more {
		&.expanded {
			display: none;
		}

		.webmd-icon-down-arrow {
			font-size: .6531rem;
			margin-left: .375rem;
		}
	}
}

.blog-category {
	color: $ultramarine;
	font-family: $base-font-family-sans;
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 25.6px;
	margin: 1rem 0;
}

.webmd-onc-article {
	article {
		&.article {
			header {
				.blog-title {
					background: $nebula;
					color: $imperial;
					font-family: $base-font-family-sans;
					font-size: 2rem;
					font-style: normal;
					font-weight: 700;
					line-height: 1.7;
					margin-bottom: 1rem;
					padding: .1875rem .625rem;
					-o-box-decoration-break: clone;
					-webkit-box-decoration-break: clone;
					backface-visibility: hidden;
					box-decoration-break: clone;
					display: inline;
					word-spacing: 0.0625rem;
				}
			}
		}
	}
}

.blog-image-container {
	margin-top: 1rem;
	min-height: 14.375rem;

	img {
		display: block;
		width: 100%;
	}
}

.blog-author-info {
	background-image: url('https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/articles/ux_images/Hero_Image.jpg');
	background-size: cover;
	color: $carbon;
	display: flex;
	font-family: $base-font-family-sans;
	font-size: .875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	padding: 1.25rem;

	a {
		color: $ultramarine;
	}

	.author-thumbnail {
		border-radius: 50%;
		height: 2.4375rem;
		margin-right: .1875rem;
		width: 2.4375rem;
	}

	.author-content {
		.publisheddate {
			border-left: 1px solid $carbon;
			margin-left: .3125rem;
			padding-left: .3125rem;
		}
	}
}
</style>
